"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _select = _interopRequireDefault(require("../select"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var defaultOperators = [{
  allowsMultipleSelect: false,
  label: 'equals to',
  value: '='
}, {
  allowsMultipleSelect: false,
  label: 'not equals to',
  value: '!='
}, {
  allowsMultipleSelect: false,
  label: 'greater than',
  value: '>'
}, {
  allowsMultipleSelect: false,
  label: 'less than',
  value: '<'
}, {
  allowsMultipleSelect: false,
  label: 'greater or equal to',
  value: '>='
}, {
  allowsMultipleSelect: false,
  label: 'less or equal to',
  value: '<='
}, {
  allowsMultipleSelect: true,
  label: 'in',
  value: 'in'
}, {
  allowsMultipleSelect: true,
  label: 'not in',
  value: 'notin'
}];
var Operator = function Operator(_ref) {
  var errors = _ref.errors,
    id = _ref.id,
    onChange = _ref.onChange,
    value = _ref.value,
    disabled = _ref.disabled,
    options = _ref.options,
    labels = _ref.labels;
  return /*#__PURE__*/_react["default"].createElement(_select["default"], {
    errors: errors,
    id: "".concat(id, "Operator"),
    placeholder: labels.ELIGIBILITY_OPERATOR_PLACEHOLDER || 'Select',
    required: true,
    searchable: false,
    options: options,
    onChange: onChange,
    value: value,
    disabled: disabled
  });
};
Operator.propTypes = {
  /** If `true`, the input will indicate an error. */
  errors: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].arrayOf(_propTypes["default"].string)]),
  /** If `true`, the input will be disabled. */
  disabled: _propTypes["default"].bool,
  /** Html id. */
  id: _propTypes["default"].string.isRequired,
  /** Callback for when changing the operator. */
  onChange: _propTypes["default"].func.isRequired,
  /** A list of operators */
  options: _propTypes["default"].arrayOf(_propTypes["default"].shape({})),
  /** Callback for when changing the operator. */
  value: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].shape({
    value: _propTypes["default"].string,
    label: _propTypes["default"].string
  })]),
  /** CMS labels */
  labels: _propTypes["default"].shape({
    ELIGIBILITY_OPERATOR_PLACEHOLDER: _propTypes["default"].string
  })
};
Operator.defaultProps = {
  options: defaultOperators,
  disabled: false,
  errors: undefined,
  value: undefined,
  labels: {}
};
var _default = exports["default"] = Operator;